export default __webpack_public_path__ + "static/media/consol-2-ar.d1ce670b.svg";